// extracted by mini-css-extract-plugin
export var chevronIcon = "_c3-2";
export var teamName = "_c3-1";
export var teamSwitcherButton = "_c3-0";